import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    banner: {
        backgroundColor: '#0F1D40',
        borderRadius: 8,
        padding: '40px 48px',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 32,
        alignItems: 'center',
        color: '#ffffff',
    },
    copy: {
        flex: '1 1 340px',
        minWidth: 0,
    },
    heading: {
        marginBottom: 10,
        letterSpacing: '-0.01em',
        color: '#ffffff',
    },
    description: {
        color: '#C3CBDC',
        maxWidth: '70ch',
    },
    ctaWrapper: {
        flex: '0 0 auto',
        marginLeft: 'auto',
    },
    ctaButton: {
        backgroundColor: '#ffffff',
        color: '#0F1D40',
        borderRadius: 5,
        padding: '15px 26px',
        fontSize: 14,
        fontWeight: 600,
        letterSpacing: '.055em',
        textTransform: 'none',
        whiteSpace: 'nowrap',
        '&:hover': {
            backgroundColor: '#E8EDF7',
        },
    },
}));
